<p-blockUI [blocked]="loading" />
@if (!this._deviceService.isMobile()) {
  <div class="ui-g ui-fluid" id="commercial-contact-action-buttons">
    <div class="buttons">
      @if (canAddCommercialContact()) {
        <button
          pButton
          class="width-eighty"
          label="{{ 'COMMON.LABEL.BUTTONS.NEW' | translate }}"
          icon="fa fa-fw fa-plus"
          (click)="addNewCommercialContact()"
        ></button>
      }
      <button
        pButton
        class="refresh-button width-twenty"
        icon="fa fa-fw fa-refresh"
        (click)="refresh()"
      ></button>
      <button
        pButton
        label="{{ 'COMMON.LABEL.BUTTONS.CLEAR' | translate }}"
        icon="fa fa-fw fa-eraser"
        (click)="clearScreen()"
      ></button>
    </div>
  </div>
}

<app-progress-spinner [enabled]="!elements" />
<div [style.display]="!elements ? 'none' : ''">
  <app-general-grid
    [values]="elements"
    [columns]="columns"
    [loading]="loading"
    [rows]="rows"
    [totalRecords]="totalRecords"
    [filterable]="true"
    [screenName]="screenName"
    [lazy]="true"
    (lazyLoad)="lazyLoad($event)"
    [includeExportCSV]="false"
    (changeViewEvent)="changeViewEvent($event)"
    [scrollHeight]="scrollHeight"
    [usePaginator]="true"
    [rowsPerPageOptions]="[50, 100, 200]"
    #grid
  />
</div>
